import { render, staticRenderFns } from "./Lingdao.vue?vue&type=template&id=53759f0c&scoped=true&"
import script from "./Lingdao.vue?vue&type=script&lang=js&"
export * from "./Lingdao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53759f0c",
  null
  
)

export default component.exports